'use client';

import React from 'react';
import { IoDownloadOutline } from 'react-icons/io5';

import { Badge, Box, Button, Card, Stack, Text, VisuallyHidden } from '@mantine/core';

import { Block } from '@marketing/components/blocks/Block';
import { ImageBlock } from '@marketing/components/blocks/ImageBlock';
import { TextBlock } from '@marketing/components/blocks/TextBlock';
import { PageHeader } from '@marketing/components/page-header/PageHeader';
import { Section } from '@marketing/components/section/Section';
import { SectionHeader } from '@marketing/components/section/SectionHeader';
import { SectionSpacer } from '@marketing/components/section/SectionSpacer';

import { ReplusLogo } from 'components/logo/ReplusLogo';

import mediaToolkitImage from '../images/media-toolkit.png';

const SAMPLE_POSTS = [
    {
        title: 'Samples Post 1',
        content: (
            <>
                Tell your designers, developers, and clients about RE+Source PRO!
                <br />
                <br />
                Exciting News! Our [insert product / service name] is now featured in RE+Source PRO, your go-to resource
                for power systems solutions! Explore our product here: https://www.directenergypartners.com
                #REPlusSourcePRO #PowerSystem
            </>
        ),
    },
    {
        title: 'Samples Post 2',
        content: (
            <>
                Need expert support for your clean energy project? We’re now listed in RE+Source PRO! Our [insert
                product / service name] can help you streamline design, deployment, and optimization. Explore our
                offerings alongside top industry providers: https://www.directenergypartners.com #REPlusSourcePRO
                #PowerSystem
            </>
        ),
    },
    {
        title: 'Samples Post 3',
        content: (
            <>
                Our [insert product / service name] is now available in RE+Source PRO - the ultimate resource for power
                system products and services.
                <br />
                <br />✅ Cutting-edge technology
                <br />✅ Seamless integration
                <br />✅ Designed for efficiency & sustainability
                <br />
                <br />
                Discover how our solution can support your next power system project:
                https://www.directenergypartners.com #REPlusSourcePRO #PowerSystem
            </>
        ),
    },
];

const MediaToolkitPage = () => {
    return (
        <>
            <PageHeader
                title={
                    <>
                        <ReplusLogo c="white" w={120} />
                        <VisuallyHidden>RE+Source PRO</VisuallyHidden>
                        <br /> Media Toolkit
                    </>
                }
                variant="dark"
                bg="purple"
                color="white"
            />

            <Section>
                <SectionHeader
                    title="Banners"
                    description="Use these banners in your email marketing, social media posts, and more."
                />

                <SectionSpacer size="sm" />

                <Block size="md">
                    <TextBlock>
                        <Box>
                            Do you have a plan for telling your customers, colleagues, and/or potential partners that
                            your product is in RE+Source PRO? Take advantage of the following social media banners and
                            shareable images to let your network know.
                        </Box>

                        <Box>
                            These images can be shared on social media or embedded into blog posts, company newsletters
                            - you name it.
                        </Box>

                        <ImageBlock image={mediaToolkitImage} mt="xl" />

                        <Button
                            component="a"
                            href="https://files.dcide.app/files/RESource_Pro_Banners.zip"
                            leftSection={<IoDownloadOutline />}
                            size="lg"
                            mx="auto"
                            mt="xl"
                        >
                            Download all banners
                        </Button>

                        <Text ta="center">Available sizes: email banner, 800 x 312, 1200 x 328, 1500 x 500</Text>
                    </TextBlock>
                </Block>
            </Section>

            <Section variant="light">
                <Block size="md">
                    <SectionHeader
                        title="Sample Posts"
                        description="Use these sample posts to let your network know about your product or service in RE+Source PRO."
                    />

                    <SectionSpacer size="sm" />

                    <Stack gap="xl">
                        {SAMPLE_POSTS.map((post) => (
                            <Card withBorder radius="md" p="xl" key={post.title}>
                                <Badge variant="outline" mb="lg">
                                    {post.title}
                                </Badge>
                                <Text fz="lg">{post.content}</Text>
                            </Card>
                        ))}
                    </Stack>
                </Block>
            </Section>
        </>
    );
};

export default MediaToolkitPage;
